import { objectToJsonString } from '@/api/object-to-json-string'
import { mutationRequest } from '@/api/utils/api-request'
import {
  ContactRequestData,
  ContactRequestResponse,
} from '@/types/contact-request-types'

export const contactRequestsMutations = {
  submit: async (
    contactRequest: ContactRequestData
  ): Promise<ContactRequestResponse> => {
    return mutationRequest<ContactRequestResponse>(
      '/landing/contact_requests',
      { method: 'POST', body: objectToJsonString({ contactRequest }) },
      'Could not create contact request'
    )
  },
}

export const submitAuthenticated = async (
  contactRequest: ContactRequestData
): Promise<ContactRequestResponse> => {
  return mutationRequest<ContactRequestResponse>(
    '/contact_requests',
    { method: 'POST', body: objectToJsonString({ contactRequest }) },
    'Could not create contact request'
  )
}
